const EventTypes = {
  COACH_SELECTED: 'coachSelected',
  EMAIL_COLLECTED: 'emailCollected',
  STRIPE_SUBSCRIPTION_CREATED: 'stripeSubscriptionCreated',
  SCHEDULE: 'onboardingAppointmentScheduled',
  STORY_SHARE_VIEWED: 'storyShareViewed',
  STORY_STYLE_SELECTED: 'storyStyleSelected',
  STORY_SHARED: 'storyShared',
  STORY_SHARE_SKIPPED: 'storyShareSkipped',
  STORY_SHARE_PAGE_OPENED: 'storySharePageOpened',
  UPSELL_OFFER_SHOWN: 'checkoutUpsellOfferShown',
  UPSELL_OFFER_ACCEPTED: 'checkoutUpsellOfferAccepted',
  UPSELL_OFFER_DECLINED: 'checkoutUpsellOfferDeclined',
};

export {
  EventTypes,
};
